<!-- views/sourcings/form.vue - Update form dyal seller -->

<template>
  <div class="flex-1 mt-1 bg-gray-100 px-4 pt-12 mb-20 items-center">
    <div class="bg-white w-full rounded-lg shadow">
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-2">
        <div class="flex">
          <button :class="$colors.primary"
            class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
            @click="RouterBack()">
            <i class="material-icons">chevron_left</i>
          </button>
          <div v-if="!formData._id" class="text-2xl font-bold text-blue-500">New Sourcing</div>
          <div v-else class="text-2xl font-bold text-blue-500">
            Edit Sourcing
            <span :class="getStatusClass(formData.status)" class="ml-3 text-sm px-3 py-1 rounded-full">
              {{ formData.status }}
            </span>
          </div>
        </div>
      </div>

      <div class="bg-white rounded-lg p-6 pt-2">
        <!-- Country & Warehouse Section -->
        <div class="px-6 mt-3">
          <div class="flex w-full space-x-2">
            <!-- Country Information -->
            <div class="flex w-1/2 justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
              <div class="flex w-full">
                <span class="rounded-full h-12 w-12 bg-gray-200">
                  <i class="material-icons p-3 text-blue-400">public</i>
                </span>
                <div class="ml-5 w-full">
                  <div class="text-base mt-1 font-semibold text-gray-600 pb-10">
                    Country Information
                  </div>
                  <div class="w-full space-y-4">
                    <!-- Country of purchase -->
                    <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 transition-all duration-500 relative rounded p-1">
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label class="bg-white text-gray-700 px-1">Country of purchase
                            <span class="text-red-500">*</span>
                          </label>
                        </p>
                      </div>
                      <p>
                        <v-select 
                          @input="setSelected" 
                          v-model="formData.country" 
                          :options="sourcingCountries" 
                          label="label"
                          :disabled="formData.status && formData.status !== 'pending' || (currentUser.type === 'Sourcing')">
                          <template slot="option" slot-scope="option">
                            <img class="flag-img" :src="$f.getCountryCode(option.code)" />
                            {{ option.label }}
                          </template>
                        </v-select>
                      </p>
                    </div>
                    
                    <!-- Warehouse -->
                    <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 transition-all duration-500 relative rounded p-1">
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label class="bg-white text-gray-700 px-1">Country warehousing
                            <span class="text-red-500">*</span>
                          </label>
                        </p>
                      </div>
                      <p>
                        <v-select 
                          @input="setSelectedW" 
                          v-model="formData.warehouse" 
                          :options="warehouses" 
                          label="name"
                          :disabled="formData.status && formData.status !== 'pending' || (currentUser.type === 'Sourcing')">
                          <template slot="option" slot-scope="option">
                            <img class="flag-img" :src="$f.getCountryCode(option.country)" />
                            {{ $f.getCountryNameByCode(options, option.country) }}
                          </template>
                        </v-select>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>


        <!-- Provider Information - Auto-filled for Sourcing Company -->
          <div v-if="showProviderSection" class="flex w-1/2 justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg">
              <div class="flex w-full mt-2">
                  <span class="rounded-full h-12 w-12 bg-gray-200">
                      <i class="material-icons p-3 text-blue-400">local_shipping</i>
                  </span>
                  <div class="ml-5 w-full">
                      <div class="text-base mt-1 font-semibold text-gray-600 pb-4">
                          Provider Information
                          <span v-if="currentUser.type === 'Sourcing'" class="text-xs text-blue-500 ml-2">
                              (Your company info)
                          </span>
                          <span v-else-if="formData.sourcingCompanyObject && formData.sourcingCompanyObject.companyName" class="text-xs text-green-500 ml-2">
                              (Filled by Sourcing Company)
                          </span>
                      </div>
                      
                      <!-- For Sourcing Company: Show their own info (read-only) -->
                      <div v-if="currentUser.type === 'Sourcing'" class="space-y-3">
                          <!-- Company Name -->
                          <div class="bg-blue-50 border border-blue-200 rounded-lg p-3">
                              <p class="text-xs text-gray-500 mb-1">Company Name</p>
                              <p class="text-sm font-semibold text-gray-800">
                                  <i class="material-icons text-sm align-middle text-blue-500 mr-1">business</i>
                                  {{ currentUser.sourcingInfo ? currentUser.sourcingInfo.companyName : currentUser.fullName }}
                              </p>
                          </div>
                          
                          <!-- Contact Info -->
                          <div class="grid grid-cols-2 gap-3">
                              <div class="bg-gray-50 border border-gray-200 rounded-lg p-3">
                                  <p class="text-xs text-gray-500 mb-1">Email</p>
                                  <p class="text-sm text-gray-700">
                                      <i class="material-icons text-xs align-middle text-gray-400 mr-1">email</i>
                                      {{ currentUser.email }}
                                  </p>
                              </div>
                              <div class="bg-gray-50 border border-gray-200 rounded-lg p-3">
                                  <p class="text-xs text-gray-500 mb-1">Phone</p>
                                  <p class="text-sm text-gray-700">
                                      <i class="material-icons text-xs align-middle text-gray-400 mr-1">phone</i>
                                      {{ currentUser.sourcingInfo ? currentUser.sourcingInfo.phone : currentUser.phone || 'N/A' }}
                                  </p>
                              </div>
                          </div>
                          
                          <!-- Info message -->
                          <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-2 text-center">
                              <p class="text-xs text-yellow-700">
                                  <i class="material-icons text-xs align-middle mr-1">info</i>
                                  This information will be sent to the seller when you submit your quote
                              </p>
                          </div>
                      </div>
                      
                      <!-- For Admin/Seller: Show Sourcing Company info (who quoted) -->
                      <div v-else-if="formData.sourcingCompanyObject && formData.sourcingCompanyObject.companyName">
                          <!-- Company Name -->
                          <div class="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-3">
                              <p class="text-xs text-gray-500 mb-1">Company Name</p>
                              <p class="text-sm font-semibold text-gray-800">
                                  <i class="material-icons text-sm align-middle text-blue-500 mr-1">business</i>
                                  {{ formData.sourcingCompanyObject.companyName }}
                              </p>
                          </div>
                          
                          <!-- Contact Info -->
                          <div class="grid grid-cols-2 gap-3">
                              <div class="bg-gray-50 border border-gray-200 rounded-lg p-3">
                                  <p class="text-xs text-gray-500 mb-1">Email</p>
                                  <p class="text-sm text-gray-700">
                                      <i class="material-icons text-xs align-middle text-gray-400 mr-1">email</i>
                                      {{ formData.sourcingCompanyObject.email }}
                                  </p>
                              </div>
                              <div class="bg-gray-50 border border-gray-200 rounded-lg p-3">
                                  <p class="text-xs text-gray-500 mb-1">Phone</p>
                                  <p class="text-sm text-gray-700">
                                      <i class="material-icons text-xs align-middle text-gray-400 mr-1">phone</i>
                                      {{ formData.sourcingCompanyObject.phone || 'N/A' }}
                                  </p>
                              </div>
                          </div>
                      </div>
                      
                      <!-- For Admin: Editable provider fields (manual entry) -->
                      <div v-else-if="['Admin', 'Administrateur'].includes(currentUser.type)" class="w-full space-y-4">
                          <!-- Provider Name -->
                          <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 transition-all duration-500 relative rounded p-1">
                              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                  <p><label class="bg-white text-gray-700 px-1">Name</label></p>
                              </div>
                              <p>
                                  <input type="text" v-model="formData.provider.name"
                                      class="py-2 text-xs px-2 outline-none block h-full w-full" />
                              </p>
                          </div>
                          
                          <!-- Provider Phone -->
                          <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 transition-all duration-500 relative rounded p-1">
                              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                  <p><label class="bg-white text-gray-700 px-1">Phone</label></p>
                              </div>
                              <p>
                                  <input type="text" v-model="formData.provider.phone"
                                      class="py-2 text-xs px-2 outline-none block h-full w-full" />
                              </p>
                          </div>
                          
                          <!-- Provider Email -->
                          <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 transition-all duration-500 relative rounded p-1">
                              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                                  <p><label class="bg-white text-gray-700 px-1">Email</label></p>
                              </div>
                              <p>
                                  <input type="email" v-model="formData.provider.email"
                                      class="py-2 text-xs px-2 outline-none block h-full w-full" />
                              </p>
                          </div>
                      </div>
                      
                      <!-- Empty state for others -->
                      <div v-else class="text-center py-4">
                          <p class="text-gray-400 text-sm">No provider information yet</p>
                      </div>
                  </div>
              </div>
          </div>

          <!-- Placeholder when Provider section hidden (Seller creating new sourcing) -->
          <div v-else class="flex w-1/2 justify-between shadow-xs items-center h-auto p-6 my-1 mb-1 rounded-lg bg-gray-50">
              <div class="flex w-full items-center justify-center text-center py-8">
                  <div>
                      <i class="material-icons text-4xl text-gray-300">hourglass_empty</i>
                      <p class="text-gray-400 mt-2">Provider information will be filled<br>by the Sourcing Company</p>
                  </div>
              </div>
          </div>

          </div>

        <!-- Status, Seller, Facturation Date -->
        <div class="bg-white rounded-lg p-6">
            <div class="grid lg:grid-cols-3 gap-6">
                <!-- Seller (Admin only) -->
                <div v-if="currentUser.type !== 'Seller' && currentUser.type !== 'Sourcing'" 
                    class="border seller-select h-10 hover:border-blue-400 focus-within:border-blue-500 transition-all duration-500 relative rounded p-1">
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                            <label class="bg-white text-gray-700 px-1">Seller <span class="text-red-500">*</span></label>
                        </p>
                    </div>
                    <p>
                        <v-select label="fullName" 
                            @search="getUsersDebance($event, 'shipsen')" 
                            v-model="formData.seller" 
                            :options="sellers"
                            :disabled="formData._id && formData.status !== 'pending'"></v-select>
                    </p>
                </div>

                <!-- Status (Admin only) -->
                <div v-if="formData._id && currentUser.type !== 'Seller' && currentUser.type !== 'Sourcing'" 
                    class="border seller-select h-10 hover:border-blue-400 focus-within:border-blue-500 transition-all duration-500 relative rounded p-1">
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                            <label class="bg-white text-gray-700 px-1">Status</label>
                        </p>
                    </div>
                    <p>
                        <select v-model="formData.status"
                            class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white">
                            <option v-for="(value, index) in statusList" :key="index" :value="value">
                                {{ value }}
                            </option>
                        </select>
                    </p>
                </div>

                <!-- Facturation Date - HIDE for Seller on creation -->
                <div v-if="showFacturationDate" 
                    class="border hover:border-blue-400 w-full focus-within:border-blue-500 transition-all duration-500 relative rounded p-1">
                    <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                            <label class="bg-white text-gray-700 px-1">
                                Facturation date
                                <span v-if="currentUser.type !== 'Seller'" class="text-red-500">*</span>
                            </label>
                        </p>
                    </div>
                    <p>
                        <datetime-v2 type="datetime" v-model="formData.facturationDate"
                            :disabled="!canEditFacturationDate"
                            placeholder="Facturation date..."
                            input-class="py-1 text-xs px-2 outline-none block h-full w-full"></datetime-v2>
                    </p>
                </div>
            </div>
        </div>

          <!-- Products Table -->

          <div class="flex w-full" v-if="canShowProducts">
            <div class="flex space-x-2 w-full shadow-xs mt-1 rounded-lg">
              <div class="flex w-full justify-between items-center h-auto p-6">
                <div class="flex w-full">
                  <span class="rounded-full h-12 w-12 bg-gray-200">
                    <i class="material-icons p-3 text-blue-500">local_mall</i>
                  </span>
                  <div class="ml-3 w-full p-2 pb-8">
                    <div class="w-full flex text-base font-semibold text-gray-600">
                      <p class="w-1/2">Products</p>
                      <div class="w-full">
                        <button v-if="canEditProducts" @click="OpenPopUp" :disabled="!canShowProducts" 
                          class="flex text-white mx-auto max-w-sm rounded-md text-center bg-blue-500 py-2 px-8 items-center focus:outline-none md:float-right hover:bg-blue-600">
                          <i class="material-icons mr-2">add</i> Select Product
                        </button>
                      </div>
                    </div>

                   <!--  Products & Fees Section REDESIGNED -->
                    <div v-if="formData.details && formData.details.length > 0" class="mt-4">
                      
                      <!-- ============================================ -->
                      <!-- PRODUCTS TABLE -->
                      <!-- ============================================ -->
                      <div class="bg-white rounded-lg border border-gray-200 overflow-hidden">
                        <div class="bg-gradient-to-r from-blue-500 to-blue-600 px-4 py-3">
                          <h4 class="text-white font-semibold flex items-center">
                            <i class="material-icons text-sm mr-2">inbox</i> 
                            Products ({{ formData.details.length }})
                          </h4>
                        </div>
                        
                        <div class="overflow-x-auto">
                          <table class="min-w-full">
                            <thead class="bg-gray-50 border-b border-gray-200">
                              <tr>
                                <th class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Product</th>
                                <th class="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider w-32">Quantity</th>
                                <th v-if="showPriceColumns" class="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider w-40">
                                  Price <span class="text-blue-500">(MAD)</span>
                                </th>
                                <th v-if="showPriceColumns && formData.warehouse" class="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider w-40">
                                  Price <span class="text-green-500">({{ formData.warehouse.currency }})</span>
                                </th>
                                <th v-if="canEditProducts" class="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider w-20">
                                  <i class="material-icons text-sm">settings</i>
                                </th>
                              </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-100">
                              <tr v-for="(item, index) in formData.details" :key="index" 
                                  class="hover:bg-blue-50 transition-colors duration-150">
                                
                                <!-- Product Info -->
                                <td class="px-4 py-3">
                                  <div class="flex items-center">
                                    <div class="flex-shrink-0 h-10 w-10 bg-gray-100 rounded-lg flex items-center justify-center">
                                      <i class="material-icons text-gray-400">shopping_bag</i>
                                    </div>
                                    <div class="ml-3">
                                      <p class="text-sm font-medium text-gray-900">
                                        {{ item.product.name || item.productObject.productName }}
                                      </p>
                                      <p class="text-xs text-gray-500">
                                        ID: #{{ item.product.id || item.productObject.productId }}
                                      </p>
                                    </div>
                                  </div>
                                </td>
                                
                                <!-- Quantity -->
                                <td class="px-4 py-3">
                                  <div v-if="canEditProducts" class="flex items-center justify-center space-x-2">
                                    <button @click="removeQuantity(index)" 
                                      class="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors">
                                      <i class="material-icons text-sm text-gray-600">remove</i>
                                    </button>
                                    <input type="number" v-model="item.quantity" min="1"
                                      class="w-16 text-center border border-gray-600 rounded-lg py-1 text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent">
                                    <button @click="addQuantity(index)" 
                                      class="w-8 h-8 rounded-full bg-blue-500 hover:bg-blue-600 flex items-center justify-center transition-colors">
                                      <i class="material-icons text-sm text-white">add</i>
                                    </button>
                                  </div>
                                  <div v-else class="text-center">
                                    <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-blue-100 text-blue-800">
                                      {{ item.quantity }} units
                                    </span>
                                  </div>
                                </td>
                                
                                <!-- Price MAD -->
                                <td v-if="showPriceColumns" class="px-4 py-3">
                                  <div v-if="canEditPrices" class="relative">
                                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                      <span class="text-gray-500 text-xs font-semibold">MAD</span>
                                    </div>
                                    <input type="number" v-model="item.priceDH" min="0" step="0.01"
                                      class="w-full pl-12 pr-3 py-2 border border-gray-600 rounded-lg text-sm text-right font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                      placeholder="0.00">
                                  </div>
                                  <div v-else class="text-center">
                                    <span class="text-sm font-semibold text-gray-700">{{ (item.priceDH || 0).toFixed(2) }}</span>
                                    <span class="text-xs text-gray-500 ml-1">MAD</span>
                                  </div>
                                </td>
                                
                                <!-- Price Currency -->
                                <td v-if="showPriceColumns && formData.warehouse" class="px-4 py-3">
                                  <div class="text-center bg-green-50 rounded-lg py-2 px-3">
                                    <span class="text-sm font-bold text-green-600">{{ (item.price || 0).toFixed(2) }}</span>
                                    <span class="text-xs text-green-500 ml-1">{{ formData.warehouse.currency }}</span>
                                  </div>
                                </td>
                                
                                <!-- Actions -->
                                <td v-if="canEditProducts" class="px-4 py-3 text-center">
                                  <button @click="removeProduct(item, index, 'products')" 
                                    class="w-8 h-8 rounded-full bg-red-100 hover:bg-red-200 flex items-center justify-center mx-auto transition-colors">
                                    <i class="material-icons text-sm text-red-500">delete</i>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <!-- ============================================ -->
                      <!-- OTHER FEES SECTION -->
                      <!-- ============================================ -->
                      <div v-if="showPriceColumns" class="mt-6 bg-white rounded-lg border border-gray-200 overflow-hidden">
                        <div class="bg-gradient-to-r from-orange-400 to-orange-500 px-4 py-3 flex justify-between items-center">
                          <h4 class="text-white font-semibold flex items-center">
                            <i class="material-icons text-sm mr-2">assignment</i> 
                            Other Fees
                            <span v-if="formData.fees && formData.fees.length > 0" class="ml-2 bg-white bg-opacity-30 text-black text-xs px-2 py-0.5 rounded-full">
                              {{ formData.fees.length }}
                            </span>
                          </h4>
                          <button v-if="canEditPrices" @click="addFees" 
                            class="bg-white bg-opacity-20 hover:bg-opacity-30 text-black text-sm px-3 py-1 rounded-lg flex items-center transition-colors">
                            <i class="material-icons text-sm mr-1 text-black">add</i> Add Fee
                          </button>
                        </div>
                        
                        <!-- Fees List -->
                        <div v-if="formData.fees && formData.fees.length > 0" class="divide-y divide-gray-100">
                          <div v-for="(fee, index) in formData.fees" :key="index" 
                              class="px-4 py-3 flex items-center hover:bg-orange-50 transition-colors">
                            
                            <!-- Remove Button -->
                            <div v-if="canEditPrices" class="mr-3">
                              <button @click="removeProduct(fee, index, 'fees')" 
                                class="w-6 h-6 rounded-full bg-red-100 hover:bg-red-200 flex items-center justify-center transition-colors">
                                <i class="material-icons text-xs text-red-500">close</i>
                              </button>
                            </div>
                            
                            <!-- Fee Icon -->
                            <div class="flex-shrink-0 h-8 w-8 bg-orange-100 rounded-lg flex items-center justify-center mr-3">
                              <i class="material-icons text-sm text-orange-500">monetization_on</i>
                            </div>
                            
                            <!-- Fee Name -->
                            <div class="flex-1 mr-4">
                              <input v-if="canEditPrices" type="text" v-model="fee.name" 
                                class="w-full border border-gray-600 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                                placeholder="Enter fee name (e.g., Shipping, Customs, Insurance...)">
                              <span v-else class="text-sm font-medium text-gray-700">{{ fee.name }}</span>
                            </div>
                            
                            <!-- Fee Price MAD -->
                            <div class="w-36 mr-3">
                              <div v-if="canEditPrices" class="relative">
                                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                  <span class="text-gray-500 text-xs font-semibold">MAD</span>
                                </div>
                                <input type="number" v-model="fee.priceDH" min="0" step="0.01"
                                  class="w-full pl-12 pr-3 py-2 border border-gray-600 rounded-lg text-sm text-right font-medium focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                                  placeholder="0.00">
                              </div>
                              <div v-else class="text-right">
                                <span class="text-sm font-semibold text-gray-700">{{ (fee.priceDH || 0).toFixed(2) }}</span>
                                <span class="text-xs text-gray-500 ml-1">MAD</span>
                              </div>
                            </div>
                            
                            <!-- Fee Price Currency -->
                            <div v-if="formData.warehouse" class="w-32">
                              <div class="text-center bg-green-50 rounded-lg py-2 px-3">
                                <span class="text-sm font-bold text-green-600">{{ (fee.price || 0).toFixed(2) }}</span>
                                <span class="text-xs text-green-500 ml-1">{{ formData.warehouse.currency }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        <!-- Empty Fees State -->
                        <div v-else class="px-4 py-8 text-center">
                          <div class="inline-flex items-center justify-center w-12 h-12 bg-gray-100 rounded-full mb-3">
                            <i class="material-icons text-gray-400">assignment</i>
                          </div>
                          <p class="text-gray-500 text-sm">No additional fees added</p>
                          <button v-if="canEditPrices" @click="addFees" 
                            class="mt-3 text-orange-500 hover:text-orange-600 text-sm font-medium">
                            <i class="material-icons text-sm align-middle mr-1">add</i> Add your first fee
                          </button>
                        </div>
                      </div>

                      <!-- ============================================ -->
                      <!-- TOTALS SUMMARY -->
                      <!-- ============================================ -->
                      <div v-if="showPriceColumns" class="mt-6 bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl p-6 text-white shadow-lg">
                        <h4 class="text-gray-400 text-sm font-semibold uppercase tracking-wider mb-4">
                          <i class="material-icons text-sm align-middle mr-1">account_balance_wallet</i> Order Summary
                        </h4>
                        
                        <div class="space-y-3">
                          <!-- Products Subtotal -->
                          <div class="flex justify-between items-center">
                            <div class="flex items-center">
                              <div class="w-8 h-8 bg-blue-500 bg-opacity-20 rounded-lg flex items-center justify-center mr-3">
                                <i class="material-icons text-sm text-blue-400">inbox</i>
                              </div>
                              <span class="text-gray-300">Products ({{ formData.details.length }} items)</span>
                            </div>
                            <div class="text-right">
                              <span class="text-lg font-semibold">{{ calculateProductsTotal.toFixed(2) }}</span>
                              <span v-if="formData.warehouse" class="text-sm text-gray-400 ml-1">{{ formData.warehouse.currency }}</span>
                            </div>
                          </div>
                          
                          <!-- Fees Subtotal -->
                          <div class="flex justify-between items-center">
                            <div class="flex items-center">
                              <div class="w-8 h-8 bg-orange-500 bg-opacity-20 rounded-lg flex items-center justify-center mr-3">
                                <i class="material-icons text-sm text-orange-400">assignment</i>
                              </div>
                              <span class="text-gray-300">Other Fees ({{ formData.fees ? formData.fees.length : 0 }})</span>
                            </div>
                            <div class="text-right">
                              <span class="text-lg font-semibold">{{ calculateFeesTotal.toFixed(2) }}</span>
                              <span v-if="formData.warehouse" class="text-sm text-gray-400 ml-1">{{ formData.warehouse.currency }}</span>
                            </div>
                          </div>
                          
                          <!-- Divider -->
                          <div class="border-t border-gray-700 my-4"></div>
                          
                          <!-- Grand Total -->
                          <div class="flex justify-between items-center">
                            <div class="flex items-center">
                              <div class="w-10 h-10 bg-green-500 rounded-lg flex items-center justify-center mr-3">
                                <i class="material-icons text-white">payments</i>
                              </div>
                              <span class="text-xl font-bold">Grand Total</span>
                            </div>
                            <div class="text-right">
                              <span class="text-3xl font-bold text-green-400">{{ (calculateProductsTotal + calculateFeesTotal).toFixed(2) }}</span>
                              <span v-if="formData.warehouse" class="text-lg text-gray-400 ml-2">{{ formData.warehouse.currency }}</span>
                            </div>
                          </div>
                          
                          <!-- MAD Equivalent -->
                          <div class="text-right text-sm text-gray-500">
                            ≈ {{ calculateTotalMAD.toFixed(2) }} MAD
                          </div>
                        </div>
                      </div>

                    </div>

                    <!-- ============================================ -->
                    <!-- EMPTY STATE - No Products -->
                    <!-- ============================================ -->
                    <div v-else class="mt-8 text-center py-16 border-2 border-dashed border-gray-600 rounded-xl bg-gray-50">
                      <div class="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4">
                        <i class="material-icons text-3xl text-blue-500">inbox</i>
                      </div>
                      <h3 class="text-lg font-semibold text-gray-700 mb-2">No Products Added</h3>
                      <p class="text-gray-500 mb-4">Start by adding products to this sourcing request</p>
                      <button v-if="canEditProducts" @click="OpenPopUp" :disabled="!canShowProducts"
                        class="inline-flex items-center bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                        <i class="material-icons mr-2">add</i> Add Products
                      </button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="w-full mt-6">
            <div class="pt-3 flex justify-end space-x-3">
              <!-- Seller: Accept/Reject when priced -->
              <!-- <template v-if="currentUser.type === 'Seller' && formData.status === 'priced'">
                <button @click="rejectSourcing"
                  class="rounded focus:outline-none text-white px-6 py-2 bg-red-500 hover:bg-red-600 transition-all duration-300">
                  <i class="material-icons text-sm align-middle mr-1">close</i> Reject
                </button>
                <button @click="acceptSourcing"
                  class="rounded focus:outline-none text-white px-6 py-2 bg-green-500 hover:bg-green-600 transition-all duration-300">
                  <i class="material-icons text-sm align-middle mr-1">check</i> Accept
                </button>
              </template> -->

              <!-- Sourcing Company: Submit Quote -->
              <template v-if="currentUser.type === 'Sourcing' && formData.status === 'pending'">
                <button @click="submitQuote" :disabled="!canSubmitQuote"
                  :class="canSubmitQuote ? 'bg-green-500 hover:bg-green-600' : 'bg-gray-400 cursor-not-allowed'"
                  class="rounded focus:outline-none text-white px-6 py-2 transition-all duration-300">
                  <i class="material-icons text-sm align-middle mr-1">send</i> Submit Quote
                </button>
              </template>

              <!-- Default Save -->
              <template v-else-if="canSave">
                <button @click="save"
                  class="rounded focus:outline-none text-white px-6 py-2 bg-blue-500 hover:bg-blue-600 transition-all duration-300">
                  <i class="material-icons text-sm align-middle mr-1">save</i> Save
                </button>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Product Selection Modal -->
    <vue-modal-2  name="Modal_products" :headerOptions="{title: 'Add Products'}" :noFooter="true" modalSize="lg" @on-close="closePopUp">
    <div class="flex p-5 pt-0  flex-col w-full h-auto mb-12">
      <!-- Header -->
      <div class="flex w-full h-auto justify-center items-center">
        <div class="flex mb-6 w-full h-auto py-3 justify-center items-center text-2xl font-bold">
          <span class="w-screen md:w-full h-10 cursor-pointer border border-gray-200 rounded text-sm flex">
            <input type="search" name="search" v-model="searchText" placeholder="Search"
              class="flex-grow px-4 rounded-l-full rounded-r-full text-sm focus:outline-none" />
            <i class="material-icons text-blue-400 m-2 mr-5 text-lg w-4 h-4">search</i>
          </span>
        </div>
      </div>
      <div>
        <div v-if="products.length <= 0" class="py-2">
          <span class="w-full flex justify-center text-center py-20 border-b border-gray-200 text-base">
            <p class="font-semibold flex text-blue-500 whitespace-no-wrap">
              <span class="">No Products found</span>
            </p>
          </span>
        </div>
        <div v-for="(item, index) in resultSearchUsers" :key="index" :value="item._id"
          class="flex space-x-12 h-auto py-1 px-5 rounded border border-gray-600 mb-2">
          <div>
            <input type="checkbox" class="form-checkbox mt-6 h-5 w-5 text-blue-500 border-blue-500"
              @change="addProductsToTemp(item, index)" v-model="item.check" />
          </div>

          <div><img :alt="item.name" :src="item.picture" class="h-16 w-16 rounded-md mx-auto" /></div>
          <div class="col-span-2 sm:col-span-4 xl:col-span-4">
            <h3 class="text-gray-80 mt-1">{{ item.name }}</h3>
            <p class="text-gray-600 text-xs"> 
              {{ exceptDes(item.description) }}
            </p>
          </div>

          <div class="mt-4 ">
            <div
              class="justify-center text-xs text-center pl-3 pr-2 w-auto bg-blue-100 font-semibold rounded-full text-blue-500">
              <p>{{ item.price }} <sup v-if="formData.warehouse">{{formData.warehouse.currency}}</sup></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer px-5 border0-t text-right">
      <button @click="closePopUp"
        class="flex text-white mx-auto max-w-sm rounded text-center bg-gray-500 py-2 px-8 items-center focus:outline-none md:float-right">
        Cancel
      </button>
      <button @click="ConfirmOperation"
        class="flex mr-2 text-white mx-auto max-w-sm rounded text-center bg-blue-500 py-2 px-8 items-center focus:outline-none md:float-right">
        Confirm
      </button>
    </div>
    </vue-modal-2>
            <!-- ******************************************************** -->
  </div>
</template>

<script>
export default {
  props: {
    currentUser: { type: Object },
    idWharhouse: { type: Object }
  },
  data() {
    return {
      formData: {
        facturationDate: null,
        provider: {
          name: "",
          phone: "",
        },
        details: [],
        fees: [],
        country: "",
        warehouse: null,
        seller: "",
        status: 'pending',
        sourcingCompany: null,
        sourcingCompanyObject: null
      },
      searchText: "",
      products: [],
      warehouses: [],
      productselected: [],
      numberItemRepeated: 0,
      sellers: [],
      statusList: ['pending', 'priced', 'accepted', 'rejected', 'effectue', 'processed'],
      sourcingCountries: [
        { label: 'China', value: 'China', code: 'CN' },
        { label: 'Dubai (UAE)', value: 'Dubai', code: 'AE' },
        { label: 'Turkey', value: 'Turkey', code: 'TR' },
        { label: 'Morocco', value: 'Morocco', code: 'MA' },
      ],
      options: this.$countries
    };
  },
  
  computed: {
    // Show price columns? (Hide for Seller on creation)
    showPriceColumns() {
        // Admin: always show
        if (['Admin', 'Administrateur'].includes(this.currentUser.type)) {
            return true;
        }
        // Sourcing: always show
        if (this.currentUser.type === 'Sourcing') {
            return true;
        }
        // Seller: only show after priced
        if (this.currentUser.type === 'Seller') {
            if (!this.formData._id) return false;
            return this.formData.status && this.formData.status !== 'pending';
        }
        return false;
    },

    // Calculate total in MAD
    calculateTotalMAD() {
        const productsMAD = this.formData.details.reduce((sum, d) => sum + ((parseFloat(d.priceDH) || 0) * (d.quantity || 1)), 0) || 0;
        const feesMAD = this.formData.fees.reduce((sum, f) => sum + (parseFloat(f.priceDH) || 0), 0) || 0;
        return productsMAD + feesMAD;
    },
     // Can show products section?
    canShowProducts() {
        // Must have warehouse selected
        if (!this.formData.warehouse) {
            return false;
        }
        
        // For Seller: they are auto-assigned, so just check warehouse
        if (this.currentUser.type === 'Seller') {
            return true;
        }
        
        // For Sourcing: always show if sourcing exists
        if (this.currentUser.type === 'Sourcing') {
            return true;
        }
        
        // For Admin: need both seller and warehouse
        if (['Admin', 'Administrateur'].includes(this.currentUser.type)) {
            return this.formData.seller && this.formData.warehouse;
        }
        
        return false;
    },
    resultSearchUsers() {
      if (this.searchText) {
        return this.products.filter((product) => {
          const regex = new RegExp(this.searchText, "i");
          return regex.test(product.name);
        });
      }
      return this.products;
    },
    // Show Facturation Date?
    showFacturationDate() {
        // Admin: always show
        if (['Admin', 'Administrateur'].includes(this.currentUser.type)) {
            return true;
        }
        
        // Sourcing Company: show (they can fill it when quoting)
        // if (this.currentUser.type === 'Sourcing') {
        //     return true;
        // }
        
        // Seller: only show AFTER sourcing is priced (read-only)
        if (this.currentUser.type === 'Seller') {
            // New sourcing = don't show
            if (!this.formData._id) {
                return false;
            }
            // Only show if status is NOT pending
            return this.formData.status && this.formData.status !== 'pending';
        }
        
        return false;
    },

    // Can edit Facturation Date?
    canEditFacturationDate() {
        // Admin: always can edit
        if (['Admin', 'Administrateur'].includes(this.currentUser.type)) {
            return true;
        }
        // Sourcing Company: can edit when pending
        if (this.currentUser.type === 'Sourcing' && this.formData.status === 'pending') {
            return true;
        }
        // Others: read-only
        return false;
    },
    // - Seller: Only show when status is priced/accepted/effectue/processed (after quote)
    // - Sourcing: Show when pending (they fill it)
    // - Admin: Always show
    showProviderSection() {
        // Admin/Administrateur: always show
        if (['Admin', 'Administrateur'].includes(this.currentUser.type)) {
            return true;
        }
        
        // Sourcing Company: show when pending (they need to fill it)
        if (this.currentUser.type === 'Sourcing') {
            return true;
        }
        
        // Seller: only show AFTER sourcing is quoted
        if (this.currentUser.type === 'Seller') {
            // New sourcing (no _id) = don't show
            if (!this.formData._id) {
                return false;
            }
            // Only show if status is NOT pending
            return this.formData.status && this.formData.status !== 'pending';
        }
        
        return false;
    },

    // Can edit Provider info?
    canEditProvider() {
        // Sourcing Company: can edit when pending
        if (this.currentUser.type === 'Sourcing' && this.formData.status === 'pending') {
            return true;
        }
        // Admin: always can edit
        if (['Admin', 'Administrateur'].includes(this.currentUser.type)) {
            return true;
        }
        // Others: read-only
        return false;
    },
    // Can edit products (Seller when pending, or Admin)
   canEditProducts() {
        // Admin: always can edit
        if (['Admin', 'Administrateur'].includes(this.currentUser.type)) {
            return true;
        }
        
        // Seller: can edit ONLY when creating new OR when status is pending
        if (this.currentUser.type === 'Seller') {
            // New sourcing (no _id) = can edit
            if (!this.formData._id) {
                return true;
            }
            // Existing sourcing with pending status = can edit
            if (this.formData.status === 'pending') {
                return true;
            }
            // Otherwise read-only
            return false;
        }
        
        // Sourcing Company: cannot edit products (only prices)
        if (this.currentUser.type === 'Sourcing') {
            return false;
        }
        
        return false;
    },
    
    // Can edit prices (Sourcing company when pending)
    canEditPrices() {
      if (this.currentUser.type === 'Sourcing' && this.formData.status === 'pending') {
        return true;
      }
      return ['Admin', 'Administrateur'].includes(this.currentUser.type);
    },
    
    // Can save
    canSave() {
      if (this.currentUser.type === 'Seller') {
        return !this.formData.status || this.formData.status === 'pending';
      }
      if (this.currentUser.type === 'Sourcing') {
        return false; // Use submitQuote instead
      }
      return true;
    },
    
    // Can submit quote (all products have prices)
    canSubmitQuote() {
      if (!this.formData.details || this.formData.details.length === 0) return false;
      return this.formData.details.every(d => d.priceDH > 0);
    },
    
    // Calculate totals
    calculateProductsTotal() {
      return this.formData.details.reduce((sum, d) => sum + (parseFloat(d.price) || 0), 0);
    },
    
    calculateFeesTotal() {
      return this.formData.fees.reduce((sum, f) => sum + (parseFloat(f.price) || 0), 0);
    }
  },
  
  watch: {
    "formData.details": {
      handler: function(newVal) {
        if (this.formData.warehouse && this.formData.warehouse.info) {
          for (let i = 0; i < newVal.length; i++) {
            newVal[i].price = (newVal[i].priceDH * newVal[i].quantity) * this.formData.warehouse.info.currency;
          }
        }
      },
      deep: true
    },
    "formData.fees": {
      handler: function(newVal) {
        if (this.formData.warehouse && this.formData.warehouse.info) {
          for (let i = 0; i < newVal.length; i++) {
            newVal[i].price = newVal[i].priceDH * this.formData.warehouse.info.currency;
          }
        }
      },
      deep: true
    }
  },
  
  async mounted() {
    this.getCurrentSeller();
    await this.dataToEdit();
  },
  
  methods: {
    RouterBack() {
      this.$router.back();
    },
     exceptDes(text){
         if (text && text.length > 60) text = text.substring(0, 60) + "...";
         return text;
      },
    
    getStatusClass(status) {
      const classes = {
        'pending': 'bg-yellow-100 text-yellow-800',
        'priced': 'bg-blue-100 text-blue-800',
        'accepted': 'bg-green-100 text-green-800',
        'rejected': 'bg-red-100 text-red-800',
        'effectue': 'bg-purple-100 text-purple-800',
        'processed': 'bg-gray-100 text-gray-800'
      };
      return classes[status] || 'bg-gray-100 text-gray-800';
    },
    
    setSelected(country) {
      if (country) {
        this.formData.country = country.value;
      } else {
        this.formData.country = "";
      }
    },
    
    async setSelectedW(warehouse) {
      this.formData.details = [];
      this.products = [];
      if(this.currentUser.type !== "Seller") this.formData.seller = null;
      if (warehouse) {
        this.formData.warehouse = warehouse;
        if (this.currentUser.type !== "Seller" && this.currentUser.type !== "Sourcing") {
          await this.getSellers(warehouse._id || warehouse);
        }
      } else {
        this.formData.warehouse = null;
      }
    },
    
    getCurrentSeller() {
      
      if (this.currentUser.type === "Seller") {
        this.formData.seller = this.currentUser;
      }
      console.log("Current User:", this.formData.seller);
      this.warehouses = this.currentUser.warehouses || [];
    },
    
    async getSellers(warehouse) {
      const res = await this.$server.search("users", { warehouses: warehouse, type: "Seller", limit: 10 });
      if (res.content.results) this.sellers = res.content.results;
      else this.sellers = [];
    },
    
    getUsersDebance: _.debounce(async function(name) {
      if (this.formData.warehouse) {
        await this.$store.dispatch('wharhouse/searchUser', {
          type: "Seller",
          warhouse: this.formData.warehouse._id || this.formData.warehouse,
          search: name
        }).then((res) => {
          this.sellers = res;
        });
      }
    }, 500),
    
    addFees() {
      this.formData.fees.push({ name: "", priceDH: 0, price: 0 });
    },
    
    addQuantity(index) {
      this.formData.details[index].quantity++;
    },
    
    removeQuantity(index) {
      if (this.formData.details[index].quantity > 1) {
        this.formData.details[index].quantity--;
      }
    },
    
    removeProduct(data, index, tab) {
      if (tab === 'products') {
        this.$confirm("Are you sure you want to delete this product?").then(async () => {
          this.formData.details.splice(index, 1);
          alert("Product deleted!", "success");
        });
      } else {
        this.formData.fees.splice(index, 1);
      }
    },
    
    // Submit quote (Sourcing Company)
    async submitQuote() {
      

      // Validate all products have prices
        const hasAllPricesMAd = this.formData.details.every(d => d.priceDH && parseFloat(d.priceDH) > 0);
        if (!hasAllPricesMAd) {
            alert('Please enter prices for all products', 'warning');
            return;
        }

        const hasAllPrices = this.formData.details.every(d => d.price && parseFloat(d.price) > 0);
        if (!hasAllPrices) {
            alert('Please enter prices for all products', 'warning');
            return;
        }

        // Auto-fill provider info from current user (Sourcing Company)
        const sourcingCompanyObject = {
            companyName: this.currentUser.sourcingInfo ? this.currentUser.sourcingInfo.companyName : this.currentUser.fullName,
            fullName: this.currentUser.fullName,
            email: this.currentUser.email,
            phone: this.currentUser.sourcingInfo ? this.currentUser.sourcingInfo.phone : this.currentUser.phone || ''
        };

        const quoteData = {
            _id: this.formData._id,
            details: this.formData.details,
            fees: this.formData.fees || [],
            provider: {
                name: sourcingCompanyObject.companyName,
                email: sourcingCompanyObject.email,
                phone: sourcingCompanyObject.phone
            },
            sourcingCompanyObject: sourcingCompanyObject,
            facturationDate: this.formData.facturationDate
        };

      
      this.$confirm("Are you sure you want to submit this quote? This action cannot be undone.").then(async () => {
       
        this.loading = true;
        const res = await this.$server.update("sourcings", { 
                quoteAction: true, 
                ...quoteData 
            });
        this.loading = false;
        console.log("Submit Quote Response:", res);
        if (res && res.data && res.data._id) {
          alert("Quote submitted successfully!", "success");
          this.$router.push('/sourcings');
        } else {
          alert(res.content || "Error submitting quote", "warning");
        }
      });
    },
    
    // Accept sourcing (Seller)
    async acceptSourcing() {
      this.$confirm("Are you sure you want to accept this quote?").then(async () => {
        this.formData.status = 'accepted';
        await this.save();
      });
    },
    
    // Reject sourcing (Seller)
    async rejectSourcing() {
      this.$confirm("Are you sure you want to reject this quote?").then(async () => {
        this.formData.status = 'rejected';
        await this.save();
      });
    },
    
    checkData() {
        // Basic required fields
        if (!this.formData.country || 
            !this.formData.details || 
            this.formData.details.length === 0 ||
            !this.formData.seller ||
            !this.formData.warehouse) {
            return false;
        }
        
        // facturationDate required only for Admin/Sourcing, NOT for Seller
        if (this.currentUser.type !== 'Seller') {
            if (!this.formData.facturationDate) {
                return false;
            }
        }
        
        return true;
    },
    
    async save() {
      if (this.formData._id) {
        const data = await this.$server.update("sourcings", this.formData);
        if (data && data._id) {
          alert("Sourcing updated", "success");
          await this.dataToEdit();
        } else {
          alert(data.content || data, "warning");
        }
      } else {
        if (this.checkData()) {
          const data = await this.$server.create("sourcings", this.formData);
          if (data && data._id) {
            this.formData = {
              provider: { name: "", phone: "" },
              details: [],
              fees: [],
            };
            if (this.currentUser.type === "Seller") this.formData.seller = this.currentUser;
            alert("Sourcing created!", "success");
          } else {
            alert(data.content || data, "warning");
          }
        } else {
          alert("You must fill all the fields!", "warning");
        }
      }
    },
    
    async dataToEdit() {
      if (this.$route.params.id) {
        const editData = await this.$server.get("sourcings", { id: this.$route.params.id });
        this.formData = editData.content;
        if (!this.formData.fees) this.formData.fees = [];
        this.formData.facturationDate = this.$moment(this.formData.facturationDate).format('yyyy-MM-DDTHH:mm');
        
        // Set country object
        const countryObj = this.sourcingCountries.find(c => c.value === this.formData.country);
        if (countryObj) this.formData.country = countryObj.value;
      }
    },
    
    async getProducts(filters) {
      if (this.formData.seller) filters.seller = this.formData.seller._id;
      filters.limit = 3000;
      const res = await this.$server.search("products", filters);
      if (res.content.results) {
        this.products = res.content.results;
      } else {
        this.products = [];
      }
    },
    
    async OpenPopUp() {
      console.log("Opening product selection popup");
      console.log("Current formData seller:", this.formData.seller);
       console.log("Current formData warehouse:", this.formData.warehouse);
      if (this.formData.seller && this.formData.warehouse) {
        await this.getProducts({});
        if (this.products.length > 0) {
          this.$vm2.open("Modal_products");
        } else {
          if (this.currentUser.type !== 'Seller') {
            alert("There are no products for the selected seller", "warning");
          } else {
            alert("You haven't added any product yet", "warning");
          }
        }
      }
    },
    
    closePopUp() {
      this.$vm2.close("Modal_products");
    },
    
    addProductsToTemp(data, index) {
      if (data.check) {
        const detail = {
          product: data,
          quantity: 1,
          priceDH: 0,
          price: 0
        };
        
        let found = this.formData.details.some(d => d.product._id === data._id);
        if (!found) {
          this.productselected.push(detail);
        } else {
          this.numberItemRepeated++;
        }
      } else {
        const pos = this.productselected.findIndex(e => e.product._id === data._id);
        if (pos !== -1) this.productselected.splice(pos, 1);
      }
    },
    
    ConfirmOperation() {
      if (this.numberItemRepeated > 0) {
        alert("There are some products already added!", "warning");
      }
      
      for (let i = 0; i < this.productselected.length; i++) {
        this.formData.details.push(this.productselected[i]);
      }
      
      this.productselected = [];
      this.numberItemRepeated = 0;
      this.$vm2.close("Modal_products");
    }
  },
};
</script>

<style scoped>
.vs__dropdown-toggle {
    border: none;
}  
.text-s{
  font-size: 12px;
}
.w-100px{
  width: 90px;
}
.w-130px{
    width: 130px;  
}
.w-160px{
    max-width: 160px;  
}
  .modal-header {
    background: #226faa;
    background: -webkit-gradient(linear,
        left top,
        right top,
        from(#226faa),
        color-stop(37%, #2989d8),
        to(#72c0d3));
    background: linear-gradient(to right, #226faa 0, #2989d8 37%, #72c0d3 100%);
    border-radius: 6px;
    color: #fff;
    padding: 18px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-color: transparent;
    border-bottom: 1px solid #e5e5e5;
  }

  .table.item thead {
    background: #3182ce4f;
    color: #fff;
    border: 0;
  }

  .toggle__dot {
    transition: all 0.3s ease-in-out;
  }

  .seller-select .vs__dropdown-toggle {
    border: none;
  }

  input:checked~.toggle__dot {
    transform: translateX(100%);
    background-color: #68d391;
  }

  /* animation for vue transition tag */
  dialog[open] {
    animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
  }

  dialog::backdrop {
    background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
    backdrop-filter: blur(3px);
  }

  @keyframes appear {
    from {
      opacity: 0;
      transform: translateX(-3rem);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  
  .toggle__dot {
  top: -.25rem;
  left: -.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #63b3ed;
}
</style>